const MARKERS = [
  '/storage/v1/object/public/report-images/',
  '/storage/v1/object/sign/report-images/',
  '/storage/v1/object/authenticated/report-images/',
];

const UUID_PREFIX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\//i;

export function reportImageStoragePath(value) {
  const raw = String(value || '').trim();
  if (!raw) return null;

  for (const marker of MARKERS) {
    const idx = raw.indexOf(marker);
    if (idx >= 0) return decodeURIComponent(raw.slice(idx + marker.length).split('?')[0]);
  }

  const relative = raw.replace(/^\.\//, '').split('?')[0];
  if (!relative.startsWith('/') && UUID_PREFIX.test(relative)) return decodeURIComponent(relative);
  return null;
}

export function isPrivateReportImageCandidate(value) {
  return Boolean(reportImageStoragePath(value));
}
